import { Result } from '@packages/domain-driven';

export const useSendContact = () => {
	const submit = (_data: unknown) => {
		try {
			// call the mutation
			return Result.ok(true);
		}
		catch  {
			// handle error her
			return Result.fail('error');
		}
	};

	return { submit };
};
